import { API } from '@shared/types/api';

export function findMetric(type: string, data: API.ListUsageMetricsQuery): number {
  return data?.metrics?.find(m => m.type === type)?.value || 0;
}
